import React from "react";
import { useI18n } from "@/i18n/I18nProvider";
import { TIDS } from "@/constants/testIds";
import { Star } from "lucide-react";

const AVATARS = [
  "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=200&q=80&auto=format&fit=crop",
  "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=200&q=80&auto=format&fit=crop",
  "https://images.pexels.com/photos/26872232/pexels-photo-26872232.jpeg?auto=compress&w=200",
];

const Testimonials = () => {
  const { t } = useI18n();
  return (
    <section className="py-20 md:py-32 bg-white" data-testid={TIDS.testimonialsSection}>
      <div className="zdc-container">
        <div className="text-center max-w-2xl mx-auto mb-12 md:mb-16">
          <div className="text-xs font-medium uppercase tracking-[0.18em] text-[#2563EB] mb-3">
            {t.testimonials.eyebrow}
          </div>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-[#111111]">
            {t.testimonials.title}
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {t.testimonials.items.map((it, i) => (
            <div
              key={i}
              data-testid={TIDS.testimonialCard}
              className="p-7 rounded-2xl border border-[#E5E7EB] bg-[#F5F7FA] card-hover hover:bg-white hover:border-[#111111]/20"
            >
              <div className="flex gap-1 mb-4">
                {[...Array(5)].map((_, s) => (
                  <Star key={s} className="w-4 h-4 fill-[#2563EB] text-[#2563EB]" />
                ))}
              </div>
              <p className="text-[15px] leading-relaxed text-[#111111] mb-6 italic">&ldquo;{it.text}&rdquo;</p>
              <div className="flex items-center gap-3">
                <img
                  src={AVATARS[i]}
                  alt={it.name}
                  className="w-11 h-11 rounded-full object-cover border border-[#E5E7EB]"
                />
                <div>
                  <div className="text-sm font-semibold text-[#111111]">{it.name}</div>
                  <div className="text-xs text-[#6B7280]">{it.role}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
